class ProductModel {
    productId?: number;
    code?: string;
    hsnCode?: string;
    productName?: string;
    productShortName?: string;
    mainGroupId?: number;
    mainGroupName?: string;
    subGroupId?: number;
    subGroupName?: string;
    unitQty?: number;
    unitFactor?: number;
    baseUnitId?: number;
    baseUnitName?: string;
    subUnitId?: number;
    subUnitName?: string;
    packetPerTray?: number;
    printingOrder?: number;
    productTaxId?: number;
    productTaxName?: string;
    baseRate?:number
    cgstRate?: number;
    sgstRate?: number;
    igstRate?: number;
    netRate?: number;
    cardRate?: number;
    freeRate?: number;  
    literPerCrate?: number;
    specialOrderRate?: number;
    isActive?: boolean;
    isIndent?: boolean;
    isCard?: boolean;
    isFree?: boolean;
    isSpecialOrder?: boolean;
    isCan?: boolean;
    isUnitRate?: boolean;
    isCommission?: boolean;
    imageFilePath?: string;
    minimumOrderQuantity?: number;
    maximumOrderQuantity?: number;
    orderinMultiplesOf?:number;
    wrapperWeight?: number;
    productWeight?: number;
}
export default ProductModel;